import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "ml-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "ml-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {useI18n} from "vue-i18n";
import {toRef} from "vue";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientlistDetailsPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const props = __props
const popupData = toRef(props, 'data');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_unref(t)("recipient.tabs.list.popups.details.name")) + ": ", 1),
    _createElementVNode("span", _hoisted_1, _toDisplayString(popupData.value.name), 1),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.list.popups.details.description")) + ": ", 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(popupData.value.description), 1),
    _hoisted_4,
    _hoisted_5,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.list.popups.details.creator")) + ": ", 1),
    _createElementVNode("span", _hoisted_6, _toDisplayString(popupData.value.owner.displayName), 1),
    _hoisted_7,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.list.popups.details.created")) + ": ", 1),
    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(DateToStringHelper)(new Date(popupData.value.createdAt))), 1),
    _hoisted_9,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.list.popups.details.changed")) + ": ", 1),
    _createElementVNode("span", _hoisted_10, _toDisplayString(popupData.value.modifiedAt ? _unref(DateToStringHelper)(new Date(popupData.value.modifiedAt)) : ""), 1),
    _hoisted_11,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.list.popups.details.activeTickets")) + ": ", 1),
    _createElementVNode("span", _hoisted_12, _toDisplayString(popupData.value.activeTickets), 1),
    _hoisted_13,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.list.popups.details.totalTickets")) + ": ", 1),
    _createElementVNode("span", _hoisted_14, _toDisplayString(popupData.value.totalTickets), 1),
    _hoisted_15,
    _hoisted_16,
    _createElementVNode("div", null, _toDisplayString(_unref(t)("recipient.tabs.list.popups.details.recipientPreview")) + ":", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popupData.value.recipientPreview, (recipient) => {
      return (_openBlock(), _createElementBlock("div", {
        key: recipient.recipientId,
        class: "ml-2"
      }, _toDisplayString(recipient.displayName) + " (" + _toDisplayString(recipient.email) + ") ", 1))
    }), 128))
  ]))
}
}

})